import React from 'react'
import {   Col, Container, Row, FormGroup, Input,  Label } from "reactstrap";
import { Formik, Field, Form, FieldProps, ErrorMessage } from "formik";
import { P, Btn } from "../../AbstractElements";
import { TransectionRepoTitle } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import * as XLSX from 'xlsx';
import HistoryTable from "../../CommonElements/SearchTable/SearchTable"
import { TransectionLogsColumn } from '../../Data/TableData/TableData';
import SearchTable from "../../CommonElements/SearchTable/SearchTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useMemo, useState } from "react";
import { decryptData} from "../../utils/helper/Crypto";
import {format} from 'date-fns'
import DataTable from 'react-data-table-component';
import { useCommonService } from '../../Service/CommonService/Commonservice';
import { useSweetAlert } from '../../Context/SweetAlertContext';
import { IoMdPrint } from 'react-icons/io';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import Datanotfound from '../../Component/PageNotFound/Datanotfound';


interface FormValues {
  FromDate: Date | null;
  ToDate: Date | null;
}


const TransectionlogPage = () => {
    const [memberID, setmemberID] = useState(decryptData(localStorage.getItem('clientId') as string))
    const [SeaarchData_date, setSeaarchData_date] =useState<any>(null)
    const [searchedData, setsearchedData] =useState<any>([])
    const [API_Payload, setAPIPayload] =useState<any>({})
    const [filterText, setFilterText] = useState("");
    const { showAlert, ShowSuccessAlert, ShowConfirmAlert } = useSweetAlert();
    const { loading, ApiCalling} = useCommonService()
    const [Rows, setRows] = useState<any>([]);
    const [Columns, setColumns] = useState<any>([])

    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 10);
     const initialValues: FormValues = { 
      FromDate:  twoDaysAgo,     
      ToDate: new Date(), 
     };
    
     const GetTableData = async ()=>{
      const formattedFromDate = format(initialValues?.FromDate!, 'dd-MMMM-yyyy');
      const formattedToDate = format(initialValues?.ToDate!, 'dd-MMMM-yyyy');
      const OBJ = {
      procName:"GetTransactionLogsReport2",
      Para:JSON.stringify({clientId:memberID, FromDate:formattedFromDate, ToDate:formattedToDate, ActionMode:"Member"})
    } 
      const res =  await ApiCalling(OBJ)
      const keys = Object.keys(res[0]); // Extract keys from the first object in the array
      const list = keys.map((col,) => ({
        name: col,
        selector: (row:any) => row[col],
        sortable: true,
        center: false,
        width:'auto',
        cell: (row:any) => (
          <div dangerouslySetInnerHTML={{ __html: row[col]}}/>
        )}));
        if(Array.isArray(res)){
          setColumns(list);
          setRows(res)
        }else{
          setColumns([]);
          setRows([])
        }
     }

     useMemo(()=>{
       // Default fromDate 
      //  console.log("working", memberID);
      GetTableData()
     },[])
    
    useEffect(()=>{  
        if(filterText){
            const lowerCaseTerm = filterText.toLowerCase(); 
            const result =  Rows.filter((obj:any) => {
              return Object.values(obj).some((value:any) =>
                    value.toString().toLowerCase().includes(lowerCaseTerm)
                        );
                      });
                      if(Array.isArray(result)){
                        console.log(result);
                        setsearchedData(result)
                      }
                    }else{
                      setsearchedData(undefined)
                    }
                  },[filterText]) 

     const handleSubmit = async(values: FormValues) => {
       const formattedFromDate = format(values.FromDate!, 'dd-MMMM-yyyy');
        const formattedToDate = format(values.ToDate!, 'dd-MMMM-yyyy');
        const OBJ = {
          procName:"GetTransactionLogsReport2",
          Para:JSON.stringify({clientId:memberID,FromDate:formattedFromDate, ToDate:formattedToDate, ActionMode:"Member"})
        }
        const res =  await ApiCalling(OBJ)
        const keys = Object.keys(res[0]); // Extract keys from the first object in the array
        const list = keys.map((col,) => ({
          name: col,
          selector: (row:any) => row[col],
          sortable: true,
          center: false,
          width:'auto',
          cell: (row:any) => (
            <div dangerouslySetInnerHTML={{ __html: row[col]}}/>
          )}));
        if(Array.isArray(res)){
          setColumns(list);
          setRows(res)
        }else{
          setColumns([]);
          setRows([])
        }
     };
  
          const exportAndPrintCSV = (data: any) => {
            if (data.length === 0) {
              showAlert('Oops!', 'No data available at the moment.');
              return;
            }
          
            // Clean data and convert to CSV format
            const cleanedData = cleanDataForExport(data);
            const csvData = XLSX.utils.sheet_to_csv(XLSX.utils.json_to_sheet(cleanedData));
          
            // Convert CSV data to an HTML table and print
            printCSVData(csvData);
          };
           // Function to convert CSV to HTML table and print
       const printCSVData = (csvData: string) => {
         // Parse CSV data into rows and columns
         const rows = csvData.split('\n').map(row => row.split(','));
     
         // Open a new window for printing
         const printWindow = window.open('', '', 'height=600,width=800');
         if (printWindow) {
           printWindow.document.open();
           printWindow.document.write(`
             <html>
             <head>
               <style>
                 body { font-family: Arial, sans-serif; }
                 table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                 th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                 th { background-color: #f2f2f2; font-weight: bold; }
                 td { white-space: pre-wrap; }
                 @media print {
                   body { margin: 0; padding: 0; }
                   button { display: none; }
                 }
               </style>
             </head>
             <body>
               <table>
                 <thead>
                   <tr>
                     ${rows[0].map(cell => `<th>${cell.trim()}</th>`).join('')}
                   </tr>
                 </thead>
                 <tbody>
                   ${rows.slice(1).map(row => `
                     <tr>
                       ${row.map(cell => `<td>${cell.trim()}</td>`).join('')}
                     </tr>
                   `).join('')}
                 </tbody>
               </table>
             </body>
             </html>
           `);
           printWindow.document.close();
           printWindow.focus();
           printWindow.print();
           printWindow.close();
         } else {
           console.error('Failed to open print window.');
         }
       };
     
          const cleanDataForExport = (data: any[]) => {
           return data.map(row => {
             const cleanedRow: any = {};
             for (let key in row) {
               if (typeof row[key] === 'string') {
                 const div = document.createElement('div');
                 div.innerHTML = row[key];
                 const inputElement = div.querySelector('input');
                 if (inputElement) {
                   // Get the value of the input field
                   cleanedRow[key] = inputElement.value || '';
                 } else {
                   cleanedRow[key] = div.textContent || div.innerText || '';
                 }
               } else {
                 cleanedRow[key] = row[key];
               }
             }
             return cleanedRow;
           });
         };
     
         const exportToExcel = (data: any) => {
           if(data.length === 0){
             showAlert('Opps!', 'No data available at the moment.');
             return
           }
           
           // Clean data to remove HTML tags
           const cleanedData = cleanDataForExport(data);
           
           // Convert cleaned data to a worksheet
           const worksheet = XLSX.utils.json_to_sheet(cleanedData);
           const workbook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
         
           // Generate Excel file and trigger download
           XLSX.writeFile(workbook, 'TableData.xlsx');
         };
  
  return (
    <div className='page-body'>
      <Breadcrumbs mainTitle={TransectionRepoTitle} parent={"Incomes"} ChildName={TransectionRepoTitle} />
      <Container fluid>
      <Col xl="12">
          <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, values, errors, touched }) => (
        <Form>
          <Row>
          <Col xl="12">
          <Row>
          <Col md="4">
          <FormGroup>
            <Label  className='text-white'>From Date:</Label>
            <Field name="FromDate">
              {({ field }:FieldProps) => (
                <DatePicker
                className={`form-control`}
                  selected={values.FromDate}
                  onChange={(date) => setFieldValue('FromDate', date)}
                  dateFormat="dd-MMMM-yyyy" // Yahan format set kiya gaya
                  placeholderText="dd-MMMM-yyyy" // Placeholder
                />
              )}
            </Field>
            <ErrorMessage name="FromDate" component="div" />
         
          </FormGroup>
          </Col>
          <Col md="4">
          <FormGroup>   
            <Label htmlFor="ToDate"  className='text-white'>To Date:</Label>
            <Field name="ToDate" className="form-control">
              {({field}: FieldProps) => (
                <DatePicker
                  selected={values.ToDate}
                  className={`form-control`}
                  onChange={(date) => setFieldValue('ToDate', date)}
                  dateFormat="dd-MMMM-yyyy" // Yahan format set kiya gaya
                  placeholderText="dd-MMMM-yyyy" // Placeholder
                />
              )}
            </Field>
            <ErrorMessage name="ToDate" component="div" />
        
          </FormGroup>
          </Col>
          <Col md="4" className="d-flex align-items-center justify-content-start pb-2 pb-md-0">
                  <Btn color="primary mt-0 mt-md-3" type="submit">Search</Btn>
                    </Col>
          </Row>
          </Col>
          </Row>
        </Form>
      )}
    </Formik>
    {loading ? (
            <Col
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "300px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Col>
          ) : (
           <Col className='mb-3'>
             <DataTable
              data={searchedData === undefined ? Rows : searchedData}
              columns={Columns}
              highlightOnHover
              pagination
              subHeader
              subHeaderComponent={
                <Col>
                  <Row className="p-0 m-0 align-items-center justify-content-end">
                    <Col className="col-12 col-md-8 p-0 d-flex justify-content-end align-items-center">
                      <input
                        className="form-control w-50"
                        placeholder="search value"
                        onChange={(e: any) => setFilterText(e.target.value)}
                      />
                      <Btn
                        color="primary px-1 py-0 py-md-2 px-md-2"
                        onClick={() => exportAndPrintCSV(Rows)}
                        style={{ margin: "10px", cursor: "pointer" }}
                      >
                        <IoMdPrint size="20" /> Print
                      </Btn>
                      <Btn
                        color="primary px-1 py-0 py-md-2 px-md-2"
                        onClick={() => exportToExcel(Rows)}
                        style={{ margin: "10px", cursor: "pointer" }}
                      >
                        <PiMicrosoftExcelLogoFill size="20" /> Excel
                      </Btn>
                    </Col>
                  </Row>
                </Col>
              }
              customStyles={{
                table: {
                  style: {
                    backgroundColor: "#030a26",
                    fontSize: "15px",
                  },
                },
                headCells: {
                  style: {
                    backgroundColor: "#3bf7ee",
                    fontSize: "15px",
                    color: "#000",
                    fontWeight: 600,
                  },
                },

                rows: {
                  style: {
                    backgroundColor: "#04172fe6",
                    fontSize: "15px",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#030a26 !important", // Hover background color
                      cursor: "pointer", // Pointer cursor on hover
                      color: "#fff !important",
                      outline: "none !important",
                    },
                  },
                },
                subHeader: {
                  style: {
                    backgroundColor: "#04172fe6", // Set the background color for the subheader
                    color: "#fff", // Set text color for subheader
                    padding: "1px", // Optional padding
                  },
                },
                pagination: {
                  style: {
                    backgroundColor: "#04172fe6", // Set your desired background color
                    color: "#fff", // Set text color
                    padding: "10px", // Optional: Add padding
                  },
                },
              }}
              noDataComponent={<Datanotfound />}
            />
           </Col>
          )}
          </Col>
      </Container>
  
    </div>
  )
}

export default TransectionlogPage